module.exports = __webpack_public_path__ + "img/jbt7123_yctd_100_4a.prt.a8f05e5a.jpg";